import { rd, type RemoteData } from '@passionware/monads';
import { Permission } from 'v5/services/front/PermissionService/PermissionService';
import type { AccessQuery } from './AccessService';

/**
 * `useCan` shares one feature-flag RemoteData across probes. Pending/idle means
 * scope or flags are still resolving — not "all features off".
 */
export function isAccessProbePending(
  canRd: (query: AccessQuery) => RemoteData<boolean>
): boolean {
  const sample = canRd({ action: Permission.RESOURCE_READ });
  return rd.isPending(sample) || rd.isIdle(sample);
}
